import { AxiosError } from "axios";
import { call, ForkEffect, put, takeLeading } from "redux-saga/effects";
import {
  getAlertsFromResidentFailure,
  getAlertsFromResidentSuccess,
} from "../../redux/alerts/actions";
import {
  ALERTS,
  IGetAlertsFromResidentRequest,
} from "../../redux/alerts/types";
import { residentsServiceStatusChange } from "../../redux/healthCheck/actions";
import { AxiosCustom } from "../../service/Axios";

export function* getAlertsFromResidentsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(ALERTS.GET_ALERTS_FROM_RESIDENT_REQUEST, getResidentsSaga);
}
function* getResidentsSaga(action: IGetAlertsFromResidentRequest) {
  try {
    const response = yield call(() => AxiosCustom.getResidents(action.payload));
    yield put(getAlertsFromResidentSuccess(response.data.items));
    // yield put(getResidentsForVitals(response.data.items));
    yield put(residentsServiceStatusChange(true));
    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;
    if (error?.response?.status === 503)
      yield put(residentsServiceStatusChange(false));
    yield put(getAlertsFromResidentFailure(e.message));
  }
}
